import React from 'react';
import PropTypes from 'prop-types';

import { formatDateTime } from 'helpers/formatters/date_time_formats';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';

import UserIcon from 'components/user_icon';

export function Row({ event, stagesConfig }) {
  const { previousStage, stage, startTime, whodunnit } = event;

  let text;
  if (previousStage) {
    if (whodunnit) {
      text = 'updated the deal stage from';
    } else {
      text = 'Deal stage updated from';
    }
  } else {
    if (whodunnit) {
      text = 'created the deal under';
    } else {
      text = 'Deal was created under';
    }
  }

  return (
    <div className="deal-history-row d-flex align-items-center gap-2 justify-content-between border-bottom py-3">
      <div className="d-flex align-items-center gap-1">
        {whodunnit && (
          <div className="d-flex align-items-center gap-1">
            <UserIcon admin={whodunnit.admin} size="sm" user={whodunnit} />
            <b>{whodunnit.admin ? 'Buildout' : whodunnit.name}</b>
          </div>
        )}
        {text}
        {previousStage && (
          <React.Fragment>
            <div className={`stage badge ${previousStage}`}>{stagesConfig[previousStage].label}</div>
            <FontAwesomeIcon className="text-muted" icon={faArrowRight} />
          </React.Fragment>
        )}
        <div className={`stage badge ${stage}`}>{stagesConfig[stage].label}</div>
      </div>

      <div className="text-muted fs-small">
        {formatDateTime(startTime)}
      </div>
    </div>
  );
}

Row.propTypes = {
  event: PropTypes.shape({
    previousStage: PropTypes.string,
    stage: PropTypes.string,
    startTime: PropTypes.string,
    whodunnit: PropTypes.object,
  }),
  stagesConfig: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
  })),
};

export default Row;
